import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';

import { SmallMultipropertySingleProperty } from 'components/smallMultipropertySingleProperty';

const Paginate = ({ items, itemsPerPage = 1 }) => {
    const [currentItems, setCurrentItems] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [itemsToShow, setItemsToShow] = useState(5);

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(items.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(items.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, items]);

    // Function to change page every 3 seconds
    const autoPaginate = () => {
        const intervalId = setInterval(() => {
            setItemOffset((prevOffset) => (prevOffset + 1) % items.length);
        }, 3000);

        return intervalId;
    };

    useEffect(() => {
        // Start automatic pagination when the component mounts
        const intervalId = autoPaginate();

        // Cleanup function to stop the interval when the component unmounts
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    // Invoke when the user clicks to request another page.
    const handlePageClick = (event) => {
        setItemOffset(event.selected * itemsPerPage);

        // Set items to show in order to have the same size always
        if (event.selected + 1 === 1 || event.selected + 1 > pageCount - 3) {
            setItemsToShow(5);
        } else if (event.selected + 1 === 2 || event.selected + 1 === 3) {
            setItemsToShow(4);
        } else {
            setItemsToShow(3);
        }
    };

    return (
        <>
            <Properties properties={currentItems} />
            <ReactPaginate
                breakLabel="..."
                nextLabel=">"
                onPageChange={handlePageClick}
                pageRangeDisplayed={itemsToShow}
                pageCount={pageCount}
                previousLabel="<"
                renderOnZeroPageCount={null}
                marginPagesDisplayed={1}
                forcePage={itemOffset / itemsPerPage} // Use itemOffset or currentPage as needed
            />
        </>
    );
};

function Properties({ properties }) {
    return (
        <>
            {properties &&
                properties.map((property, index) => (
                    <SmallMultipropertySingleProperty
                        key={index}
                        singleProperty={property}
                    />
                ))}
        </>
    );
}

Paginate.propTypes = {
    items: PropTypes.array,
    itemsPerPage: PropTypes.number,
};

Properties.propTypes = {
    properties: PropTypes.array,
};

export default Paginate;
